import { render, staticRenderFns } from "./OnboardingGameIntegrationSelectorCopyStake.vue?vue&type=template&id=366658a0&scoped=true&lang=pug"
import script from "./OnboardingGameIntegrationSelectorCopyStake.vue?vue&type=script&lang=ts"
export * from "./OnboardingGameIntegrationSelectorCopyStake.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingGameIntegrationSelectorCopyStake.vue?vue&type=style&index=0&id=366658a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366658a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VRadio,VRadioGroup})
